import gql from 'graphql-tag'

export default gql`query ($textFilters: [KeyValueInput], $dateFilters: [KeyValueInput], $sorts: [KeyValueInput], $limit: Int, $offset: Int){
  total_project_client_invoices(textFilters: $textFilters, dateFilters: $dateFilters)
  project_client_invoices(textFilters: $textFilters, dateFilters: $dateFilters, sorts: $sorts, limit: $limit, offset: $offset){
    id
    invoice_number
    project{
      project_id
      name
      clients{
        client_id
        name
      }
      
    }
    client{
      client_id
      name
      contacts{
        contact_id
        first_name
        last_name
      }
    }
    issued_at
    paid_at
    created_at
    invoice_url
    invoice_total
    breakdown{
      id
      description
      amount
    }
    credit_notes{
      id
      invoice_number
      invoice_url
      invoice_total
      created_at
      breakdown{
        id
        description
        amount
      }
    }
  }
}`